import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class HttpCancelService {
	private pendingHTTPRequests$ = new Subject<void>();
	private loginSetupRequests = new Subject<void>();
	private LOGIN_SETUP_URL = 'loginSetup';

	constructor() {}

	public cancelPendingRequests() {
		this.pendingHTTPRequests$.next();
	}

	public onCancelPendingRequests(req: any) {
		if (req.url.indexOf(this.LOGIN_SETUP_URL) == -1) {
			return this.pendingHTTPRequests$.asObservable();
		} else {
			return this.loginSetupRequests.asObservable();
		}
	}
}
